import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  BookOpen, 
  Search, 
  Calendar, 
  ExternalLink, 
  Copy, 
  Check, 
  Layers, 
  Bookmark, 
  FileText,
  Filter
} from 'lucide-react';

const publicationsData = [
  // --- JOURNAL PAPERS (1 - 109) ---
  {
    id: "j-1",
    type: "Journal Paper",
    year: "2024",
    title: "Berrylush: scaling for growth",
    authors: "Lamba, H. K., Sengupta, S., Paul, A. J., & Dhir, S.",
    source: "Emerald Emerging Markets Case Studies, 14(4), 1-25",
    link: ""
  },
  {
    id: "j-2",
    type: "Journal Paper",
    year: "2024",
    title: "Critical Success Factors in Managing Strategic Alliances and Knowledge for Organizational Innovations: Insights with M-TISM and MICMAC",
    authors: "Priyanka, P., Rajan, R., Chikhale, M., & Dhir, S.",
    source: "IEEE Engineering Management Review",
    link: ""
  },
  {
    id: "j-3",
    type: "Journal Paper",
    year: "2024",
    title: "Vaccine hesitancy: a structured review from a behavioral perspective (2015–2022)",
    authors: "Acharya, S., Aechtner, T., Dhir, S., & Venaik, S.",
    source: "Psychology, Health & Medicine, 1-29",
    link: ""
  },
  {
    id: "j-4",
    type: "Journal Paper",
    year: "2024",
    title: "Mapping the critical factors of emerging technologies adoption intention in foodservice industry: a modified total interpretive structural modeling approach",
    authors: "Singh, S., & Dhir, S.",
    source: "Journal of Foodservice Business Research, 1-30",
    link: ""
  },
  {
    id: "j-5",
    type: "Journal Paper",
    year: "2024",
    title: "Sustaining the mobile medical units to bring equity in healthcare: a PLS-SEM approach",
    authors: "Patel, J., More, S., Sohani, P., Bedarkar, S., Dinesh, K. K., Sharma, D., … & Ghosh, R. S.",
    source: "International Journal for Equity in Health, 23(1), 175",
    link: ""
  },
  {
    id: "j-6",
    type: "Journal Paper",
    year: "2024",
    title: "Critical success factors for emerging technology adoption, strategic flexibility, and competitiveness: An evidence-based total interpretive structural modeling approach (TISM-E)",
    authors: "Singh, S., Singh, S., Chikhale, M., & Dhir, S.",
    source: "Global Journal of Flexible Systems Management, 25(3), 601-628",
    link: ""
  },
  {
    id: "j-7",
    type: "Journal Paper",
    year: "2024",
    title: "Characterizing generative artificial intelligence applications: Text-mining-enabled technology roadmapping",
    authors: "Singh, S., Singh, S., Kraus, S., Sharma, A., & Dhir, S.",
    source: "Journal of Innovation & Knowledge, 9(3), 100531",
    link: ""
  },
  {
    id: "j-8",
    type: "Journal Paper",
    year: "2024",
    title: "The role of community mobilization in people’s healthcare-seeking behavior during the COVID-19 vaccination journey: select case studies from Madhya Pradesh",
    authors: "Das, P., Shukla, S., Shrivastav, V., Purohit, S., Sharma, D., Dhir, S., … & Ghosh, R. S.",
    source: "Humanities and Social Sciences Communications, 11(1), 1-11",
    link: ""
  },
  {
    id: "j-9",
    type: "Journal Paper",
    year: "2024",
    title: "Ensuring Vaccine Temperature Integrity: Monitoring from Storage to Last-Mile Delivery",
    authors: "Lamba, H. K., Sharma, D., Dhir, S., Sushil, S., Ghosh, R. S., Bagchi, S. N., … & Doshi, J.",
    source: "Global Journal of Flexible Systems Management, 1-20",
    link: ""
  },
  {
    id: "j-10",
    type: "Journal Paper",
    year: "2024",
    title: "The Emotions for COVID-19 vaccine: Insights from Twitter analytics about hesitancy and willingness for vaccination",
    authors: "Singh, S., & Dhir, S.",
    source: "Journal of Policy Modeling",
    link: ""
  },
  {
    id: "j-11",
    type: "Journal Paper",
    year: "2024",
    title: "Critical factors for capacity building of NGOs working in the intellectual disability sector in India: a TISM-MICMAC approach",
    authors: "Rajan, R., Jain, M., & Dhir, S.",
    source: "Journal of Asia Business Studies",
    link: ""
  },
  {
    id: "j-12",
    type: "Journal Paper",
    year: "2024",
    title: "Analyzing institutional factors influencing the national innovation system",
    authors: "Singh, S., Dhir, S., Mukunda Das, V., & Sharma, A.",
    source: "Journal of Science and Technology Policy Management",
    link: ""
  },
  {
    id: "j-13",
    type: "Journal Paper",
    year: "2024",
    title: "Cost analysis of different medical oxygen sources for a healthcare facility in India",
    authors: "Manhas, V., Rawat, M., Kaurav, Y. S., Goyal, S., Dhir, S., & Sangineni, K.",
    source: "Indian Journal of Anaesthesia, 68(4), 374-379",
    link: ""
  },
  {
    id: "j-14",
    type: "Journal Paper",
    year: "2024",
    title: "Coopetition, strategy, and business performance in the era of digital transformation using a multi-method approach: Some research implications for strategy and operations management",
    authors: "Meena, A., Dhir, S., & Sushil, S.",
    source: "International Journal of Production Economics, 270, 109068",
    link: ""
  },
  {
    id: "j-15",
    type: "Journal Paper",
    year: "2024",
    title: "Impact of digital marketing on the competitiveness of the restaurant industry",
    authors: "Singh, S., Singh, G., & Dhir, S.",
    source: "Journal of Foodservice Business Research, 27(2), 109-137",
    link: ""
  },
  {
    id: "j-16",
    type: "Journal Paper",
    year: "2024",
    title: "Bibliometric analysis of vaccine hesitancy research from behavioural perspectives (2015–2022)",
    authors: "Acharya, S., Aechtner, T., Venaik, S., & Dhir, S.",
    source: "Psychology & Behavioral Health Literature Review",
    link: ""
  },
  {
    id: "j-17",
    type: "Journal Paper",
    year: "2024",
    title: "Reshaping the equitable and inclusive access to healthcare: A qualitative study",
    authors: "Patel, J., More, S., Sohani, P., Bedarkar, S., Dinesh, K. K., Sharma, D., … & Ghosh, R. S.",
    source: "Clinical Epidemiology and Global Health, 101544",
    link: ""
  },
  {
    id: "j-18",
    type: "Journal Paper",
    year: "2023",
    title: "Market orientation, technological capability, and firm performance: an empirical study with PLS-SEM approach",
    authors: "Rubina Chakma & Sanjay Dhir",
    source: "Technology Analysis & Strategic Management",
    link: ""
  },
  {
    id: "j-19",
    type: "Journal Paper",
    year: "2023",
    title: "Blockchain in the age of industrial revolution: A systematic literature review using bibliometric analysis",
    authors: "Gupta, R., Meena, A., & Dhir, S.",
    source: "Global Business and Organizational Excellence",
    link: ""
  },
  {
    id: "j-20",
    type: "Journal Paper",
    year: "2023",
    title: "Coopetition, strategy, and business performance in the era of digital transformation using a multi-method approach",
    authors: "Meena, A., Dhir, S., & Sushil, S.",
    source: "International Journal of Production Economics, 109068",
    link: ""
  },
  {
    id: "j-21",
    type: "Journal Paper",
    year: "2023",
    title: "Bibliometric Review of Blended Finance and Partial Risk Guarantee: Establishing Needs and Advantages",
    authors: "Sharma, K., Mahna, T., Jain, S., Dhir, S., Rao, N., Biyani, A., … & Gupta, A.",
    source: "International Journal of Financial Studies, 11(3), 103",
    link: ""
  },
  {
    id: "j-22",
    type: "Journal Paper",
    year: "2023",
    title: "Soft computing in business: exploring current research and outlining future research directions",
    authors: "Singh, S., Singh, S., Koohang, A., Sharma, A., & Dhir, S.",
    source: "Industrial Management & Data Systems, 123(8), 2079-2127",
    link: ""
  },
  {
    id: "j-23",
    type: "Journal Paper",
    year: "2023",
    title: "The evolving relationship of entrepreneurship, technology, and innovation: A topic modeling perspective",
    authors: "Singh, S., Singh, S., & Dhir, S.",
    source: "The International Journal of Entrepreneurship and Innovation, 14657503231179597",
    link: ""
  },
  {
    id: "j-24",
    type: "Journal Paper",
    year: "2023",
    title: "Examining the Impact of Key Factors on COVID-19 Vaccination Coverage in India: A PLS-SEM Approach",
    authors: "Dhawan, V., Aggarwal, M. K., Dhalaria, P., Kharb, P., Sharma, D., Dinesh, K. K., … & Ghosh, R. S.",
    source: "Vaccines, 11(4), 868",
    link: ""
  },
  {
    id: "j-25",
    type: "Journal Paper",
    year: "2023",
    title: "Toward improved international joint ventures performance in India: the mediating role of ambidexterity and the moderating role of environmental dynamism",
    authors: "Batra, I., & Dhir, S.",
    source: "Cross Cultural & Strategic Management",
    link: ""
  },
  {
    id: "j-26",
    type: "Journal Paper",
    year: "2023",
    title: "Exploring the determinants of ambidexterity in the context of Small and Medium Enterprises (SMEs): A meta-analytical review",
    authors: "Chakma, R., & Dhir, S.",
    source: "Journal of Management & Organization, 1-29",
    link: ""
  },
  {
    id: "j-27",
    type: "Journal Paper",
    year: "2023",
    title: "Integrating knowledge management and dynamic capabilities through TISM modeling and meta-analysis",
    authors: "Bindra, S., Bhardwaj, R., & Dhir, S.",
    source: "Management Research Review, 46(4), 534-556",
    link: ""
  },
  {
    id: "j-28",
    type: "Journal Paper",
    year: "2023",
    title: "Knowledge transfer and innovation in multinationals: a review of the literature using SCM-TBFO framework",
    authors: "Singh, S., & Dhir, S.",
    source: "Benchmarking: An International Journal",
    link: ""
  },
  {
    id: "j-29",
    type: "Journal Paper",
    year: "2023",
    title: "Analysing the Antecedents of Entrepreneurial Bootstrapping and Bricolage: A Modified Total Interpretive Structural Modelling and MICMAC Approach",
    authors: "Singh, M., Dhir, S., & Mishra, H.",
    source: "The Journal of Entrepreneurship, 32(1), 7-38",
    link: ""
  },
  {
    id: "j-30",
    type: "Journal Paper",
    year: "2023",
    title: "Modeling a COVID-19 vaccination campaign in the State of Madhya Pradesh, India",
    authors: "Das, P., Shukla, S., Bhagwat, A., Purohit, S., Dhir, S., Sushil, … & Ghosh, R. S.",
    source: "Global Journal of Flexible Systems Management, 24(1), 143-161",
    link: ""
  },
  {
    id: "j-31",
    type: "Journal Paper",
    year: "2023",
    title: "Data analytics and knowledge management approach for COVID-19 prediction and control",
    authors: "Hasan, I., Dhawan, P., Rizvi, S. A. M., & Dhir, S.",
    source: "International Journal of Information Technology, 15(2), 937-954",
    link: ""
  },
  {
    id: "j-32",
    type: "Journal Paper",
    year: "2023",
    title: "Understanding the dynamics of entrepreneurial implementation during the COVID-19 pandemic",
    authors: "Sengupta, S., & Dhir, S.",
    source: "Benchmarking: An International Journal",
    link: ""
  },
  {
    id: "j-33",
    type: "Journal Paper",
    year: "2023",
    title: "Circular economy and sustainable development: A review and research agenda",
    authors: "Lamba, H. K., Kumar, N. S., & Dhir, S.",
    source: "International Journal of Productivity and Performance Management",
    link: ""
  },
  {
    id: "j-34",
    type: "Journal Paper",
    year: "2023",
    title: "A review of coopetition and future research agenda",
    authors: "Meena, A., Dhir, S., & Sushil, S.",
    source: "Journal of Business & Industrial Marketing, 38(1), 118-136",
    link: ""
  },
  {
    id: "j-35",
    type: "Journal Paper",
    year: "2023",
    title: "Academic bioinformatics activities joining hands with entrepreneurial ventures: a way to go in life science research",
    authors: "Shekhar, S., Dhir, S., Gomes, J., & Jayaram, B.",
    source: "International Journal of Research, Innovation and Commercialisation, 5(1), 70-105",
    link: ""
  },
  {
    id: "j-36",
    type: "Journal Paper",
    year: "2023",
    title: "The role of meta-organisation in sustainability for emerging markets",
    authors: "Lamba, H. K., & Dhir, S.",
    source: "International Journal of Management Concepts and Philosophy, 16(2), 126-144",
    link: ""
  },
  {
    id: "j-37",
    type: "Journal Paper",
    year: "2023",
    title: "Hierarchical Modeling of Critical Factors of Coopetition for Improved Business Performance in IT Organizations: An Empirical Analysis",
    authors: "Meena, A., & Dhir, S.",
    source: "International Journal of Production Economics",
    link: ""
  },
  {
    id: "j-38",
    type: "Journal Paper",
    year: "2023",
    title: "Knowledge‐based dynamic capability: Concept mapping, usage, and taxonomy",
    authors: "Bindra, S., Sharma, D., Bhardwaj, R., Dhir, S., & Srivastava, S.",
    source: "Knowledge and Process Management, 30(1), 65-82",
    link: ""
  },
  {
    id: "j-39",
    type: "Journal Paper",
    year: "2022",
    title: "Developing an evidence-based TISM: an application for the success of COVID-19 Vaccination Drive",
    authors: "Singh, S., Dhir, S., & Sushil, S.",
    source: "Annals of Operations Research, 1-19",
    link: ""
  },
  {
    id: "j-40",
    type: "Journal Paper",
    year: "2022",
    title: "Synthesizing research in entrepreneurial bootstrapping and bricolage: a bibliometric mapping and TCCM analysis",
    authors: "Singh, M., Dhir, S., & Mishra, H.",
    source: "Management Review Quarterly, 1-34",
    link: ""
  },
  {
    id: "j-41",
    type: "Journal Paper",
    year: "2022",
    title: "Developing structural modelling of inter-partner factors of international joint ventures performance",
    authors: "Batra, I., & Dhir, S.",
    source: "International Journal of Productivity and Performance Management",
    link: ""
  },
  {
    id: "j-42",
    type: "Journal Paper",
    year: "2022",
    title: "Marketing resources, competitive advantage, and marketing performance: a modified TISM and MICMAC approach",
    authors: "Chakma, R., Dhir, S., Ongsakul, V., Sakka, G., & Ahmed, Z. U.",
    source: "Journal of Strategic Marketing, 1-17",
    link: ""
  },
  {
    id: "j-43",
    type: "Journal Paper",
    year: "2021",
    title: "Deciphering the impact of responsiveness on customer satisfaction, cross-buying behaviour, revisit intention and referral behaviour",
    authors: "Sharma, D., Paul, J., Dhir, S., & Taggar, R.",
    source: "Asia Pacific Journal of Marketing and Logistics",
    link: "https://doi.org/10.1108/APJML-07-2021-0465"
  },
  {
    id: "j-44",
    type: "Journal Paper",
    year: "2021",
    title: "Modeling the effects of digital transformation in Indian manufacturing industry",
    authors: "Singh, S., Sharma, M., & Dhir, S.",
    source: "Technology in Society, 67, 1-11",
    link: "https://www.sciencedirect.com/science/article/pii/S0160791X21002384"
  },
  {
    id: "j-45",
    type: "Journal Paper",
    year: "2021",
    title: "Organizational Ambidexterity: A Review and Research Agenda",
    authors: "Chakma, R., Paul, J., & Dhir, S.",
    source: "IEEE Transactions on Engineering Management",
    link: "https://ieeexplore.ieee.org/abstract/document/9580745"
  },
  {
    id: "j-46",
    type: "Journal Paper",
    year: "2021",
    title: "Dynamics of the termination of global alliances: probing the past, analyzing the present and defining the frontiers for future research",
    authors: "Parameswar, N., Dhir, S., Khoa, T. T., Galati, A., & Ahmed, Z. U.",
    source: "International Marketing Review",
    link: "https://doi.org/10.1108/IMR-01-2021-0046"
  },
  {
    id: "j-47",
    type: "Journal Paper",
    year: "2021",
    title: "A Meta-Analytical Review of Antecedents of Organizational Ambidexterity",
    authors: "Batra, I., Preethi, P., & Dhir, S.",
    source: "International Journal of Knowledge Management (IJKM), 17(4), 28-51",
    link: "https://www.igi-global.com/article/a-meta-analytical-review-of-antecedents-of-organizational-ambidexterity/288320"
  },
  {
    id: "j-48",
    type: "Journal Paper",
    year: "2021",
    title: "Dynamic modeling of strategic thinking for top management teams and its impact on firm performance: a system dynamics approach",
    authors: "Shaik, A. S., & Dhir, S.",
    source: "Journal of Management Development",
    link: "https://doi.org/10.1108/JMD-09-2020-0298"
  },
  {
    id: "j-49",
    type: "Journal Paper",
    year: "2021",
    title: "The trajectory of two decades of global journal of flexible systems management and flexibility research: A bibliometric analysis",
    authors: "Singh, S., Dhir, S., & Evans, S.",
    source: "Global Journal of Flexible Systems Management, 22(4), 377-401",
    link: "https://link.springer.com/article/10.1007/s40171-021-00286-6"
  },
  {
    id: "j-50",
    type: "Journal Paper",
    year: "2021",
    title: "Critical factors in capacity building of NGOs in the intellectual disability sector in India: PLS SEM modelling",
    authors: "Jain, M., & Dhir, S.",
    source: "International Journal of Health Governance",
    link: "https://doi.org/10.1108/IJHG-06-2021-0069"
  },
  {
    id: "j-51",
    type: "Journal Paper",
    year: "2021",
    title: "Role of management practices and their effects on firm performance: Emerging market context",
    authors: "Parameswar, N., Hasan, Z., & Dhir, S.",
    source: "Strategic Change, 30(5), 467-479",
    link: "https://onlinelibrary.wiley.com/doi/abs/10.1002/jsc.2461"
  },
  {
    id: "j-52",
    type: "Journal Paper",
    year: "2021",
    title: "What drives organisational performance: strategic thinking, technological change, strategic risks? A modified total interpretive structural modelling approach and MICMAC analysis",
    authors: "Shaik, A. S., & Dhir, S.",
    source: "Journal of Indian Business Research",
    link: "https://www.emerald.com/insight/content/doi/10.1108/JIBR-09-2020-0309/full/html"
  },
  {
    id: "j-53",
    type: "Journal Paper",
    year: "2021",
    title: "Antecedents of strategic thinking and its impact on competitive advantage",
    authors: "Dixit, S., Singh, S., Dhir, S., & Dhir, S.",
    source: "Journal of Indian Business Research",
    link: "https://doi.org/10.1108/JIBR-08-2020-0262"
  },
  {
    id: "j-54",
    type: "Journal Paper",
    year: "2021",
    title: "Antecedents of international joint ventures’ past, present and future: a meta-analytical review",
    authors: "Batra, I., Gupta, M., & Dhir, S.",
    source: "International Journal of Emerging Markets",
    link: "https://doi.org/10.1108/IJOEM-01-2020-0053"
  },
  {
    id: "j-55",
    type: "Journal Paper",
    year: "2021",
    title: "Developing a modified total interpretive structural model (M-TISM) for organizational strategic cybersecurity management",
    authors: "Rajan, R., Rana, N. P., Parameswar, N., Dhir, S., Sushil, & Dwivedi, Y. K.",
    source: "Technological Forecasting and Social Change, 170, 120872",
    link: "https://www.sciencedirect.com/science/article/pii/S0040162521003048"
  },
  {
    id: "j-56",
    type: "Journal Paper",
    year: "2021",
    title: "Use of microblogging platform for digital communication in politics",
    authors: "Paul, J., Parameswar, N., Sindhani, M., & Dhir, S.",
    source: "Journal of Business Research, 127, 322-331",
    link: "https://www.sciencedirect.com/science/article/pii/S0148296321000564"
  },
  {
    id: "j-57",
    type: "Journal Paper",
    year: "2021",
    title: "Innovation implementation in Asia-Pacific countries: a review and research agenda",
    authors: "Singh, S., Paul, J., & Dhir, S.",
    source: "Asia Pacific Business Review, 27(2), 180-208",
    link: "https://www.tandfonline.com/doi/full/10.1080/13602381.2021.1859748"
  },
  {
    id: "j-58",
    type: "Journal Paper",
    year: "2021",
    title: "Modified total interpretive structural modelling of innovation implementation antecedents",
    authors: "Singh, S., & Dhir, S.",
    source: "International Journal of Productivity and Performance Management",
    link: "https://www.emerald.com/insight/content/doi/10.1108/IJPPM-05-2020-0239/full/html"
  },
  {
    id: "j-59",
    type: "Journal Paper",
    year: "2021",
    title: "Black swan: bibliometric analysis and development of research agenda",
    authors: "Parameswar, N., Chaubey, A., & Dhir, S.",
    source: "Benchmarking: An International Journal",
    link: "https://www.emerald.com/insight/content/doi/10.1108/BIJ-08-2020-0443/full/html"
  },
  {
    id: "j-60",
    type: "Journal Paper",
    year: "2021",
    title: "Employability implications of artificial intelligence in healthcare ecosystem: responding with readiness",
    authors: "Jain, M., Goel, A., Sinha, S., & Dhir, S.",
    source: "Foresight",
    link: "https://www.emerald.com/insight/content/doi/10.1108/FS-04-2020-0038/full/html"
  },
  {
    id: "j-61",
    type: "Journal Paper",
    year: "2021",
    title: "Critical success factors determining performance of cross‐border acquisition: Evidence from the African telecom market",
    authors: "Dhir, S., Rajan, R., Ongsakul, V., Owusu, R. A., & Ahmed, Z. U.",
    source: "Thunderbird International Business Review, 63(1), 43-61",
    link: "https://onlinelibrary.wiley.com/doi/pdf/10.1002/tie.22156"
  },
  {
    id: "j-62",
    type: "Journal Paper",
    year: "2020",
    title: "Technology management for innovation in organizations: an argumentation-based modified TISM approach",
    authors: "Rajan, R., Dhir, S., & Sushil",
    source: "Benchmarking: An International Journal",
    link: "https://www.emerald.com/insight/content/doi/10.1108/BIJ-01-2020-0019/full/html"
  },
  {
    id: "j-63",
    type: "Journal Paper",
    year: "2020",
    title: "Integration of knowledge and enhancing competitiveness: A case of acquisition of Zain by Bharti Airtel",
    authors: "Dhir, S., Ongsakul, V., Ahmed, Z. U., & Rajan, R.",
    source: "Journal of Business Research, 119, 674-684",
    link: "https://www.sciencedirect.com/science/article/pii/S014829631930147X"
  },
  {
    id: "j-64",
    type: "Journal Paper",
    year: "2020",
    title: "Unboxing Hulu: a tale of strategic alliance to survive in the sharing world",
    authors: "Lamba, H. K., Meena, A., Srivastava, S., & Khoa, T. T.",
    source: "Journal for Global Business Advancement, 13(3), 296-320",
    link: "https://www.inderscienceonline.com/doi/abs/10.1504/JGBA.2020.111015"
  },
  {
    id: "j-65",
    type: "Journal Paper",
    year: "2020",
    title: "Antecedents of innovation implementation: a review of literature with meta-analysis",
    authors: "Singh, S., Dhir, S., Gupta, A., Das, V. M., & Sharma, A.",
    source: "Foresight",
    link: "https://www.emerald.com/insight/content/doi/10.1108/FS-03-2020-0021/full/html"
  },
  {
    id: "j-66",
    type: "Journal Paper",
    year: "2020",
    title: "An analysis of growth-accelerating factors for the Indian automotive industry using modified TISM",
    authors: "Meena, A., Dhir, S., & Sushil",
    source: "International Journal of Productivity and Performance Management",
    link: "https://www.emerald.com/insight/content/doi/10.1108/IJPPM-01-2019-0047/full/html"
  },
  {
    id: "j-67",
    type: "Journal Paper",
    year: "2020",
    title: "A systematic review of responsiveness to develop future research agenda: a TCCM and bibliometric analysis",
    authors: "Sharma, D., Taggar, R., Bindra, S., & Dhir, S.",
    source: "Benchmarking: An International Journal, 27(9), 2649-2677",
    link: "https://www.emerald.com/insight/content/doi/10.1108/BIJ-12-2019-0539/full/html"
  },
  {
    id: "j-68",
    type: "Journal Paper",
    year: "2020",
    title: "Factor Affecting Innovation Performance of Manufacturing Firms: Case Evidences",
    authors: "Dhir, S., & Dhir, S.",
    source: "International Journal of Asian Business and Information Management (IJABIM), 11(3), 85-100",
    link: "https://www.igi-global.com/article/factor-affecting-innovation-performance-of-manufacturing-firms/255698"
  },
  {
    id: "j-69",
    type: "Journal Paper",
    year: "2020",
    title: "Service innovation implementation: a systematic review and research agenda",
    authors: "Singh, S., Akbani, I., & Dhir, S.",
    source: "The Service Industries Journal, 40(7-8), 491-517",
    link: "https://www.tandfonline.com/doi/full/10.1080/02642069.2020.1731477"
  },
  {
    id: "j-70",
    type: "Journal Paper",
    year: "2020",
    title: "Culture and International business research: A review and research agenda",
    authors: "Srivastava, S., Singh, S., & Dhir, S.",
    source: "International Business Review, 29(4), 1-15",
    link: "https://www.sciencedirect.com/science/article/pii/S0969593120300470"
  },
  {
    id: "j-71",
    type: "Journal Paper",
    year: "2020",
    title: "Bibliometric overview of the technological forecasting and social change journal: analysis from 1970 to 2018",
    authors: "Singh, S., Dhir, S., Das, V. M., & Sharma, A.",
    source: "Technological Forecasting and Social Change, 154, 1-26",
    link: "https://www.sciencedirect.com/science/article/pii/S0040162519305220"
  },
  {
    id: "j-72",
    type: "Journal Paper",
    year: "2020",
    title: "Alliance termination research: a bibliometric review and research agenda",
    authors: "Rajan, R., Dhir, S., & Sushil",
    source: "Journal of Strategy and Management, 13(3), 351-375",
    link: "https://www.emerald.com/insight/content/doi/10.1108/JSMA-10-2019-0184/full/html"
  },
  {
    id: "j-73",
    type: "Journal Paper",
    year: "2020",
    title: "Interpretive ranking of choice of interaction of parent firms post-international joint venture termination using TISM-IRP",
    authors: "Parameswar, N., & Dhir, S.",
    source: "Global Journal of Flexible Systems Management, 21(1), 1-16",
    link: "https://link.springer.com/article/10.1007/s40171-019-00227-4"
  },
  {
    id: "j-74",
    type: "Journal Paper",
    year: "2020",
    title: "Customer competency for improving firm decision-making performance in e-commerce",
    authors: "Gupta, V., Gupta, L., & Dhir, S.",
    source: "Foresight",
    link: "https://www.emerald.com/insight/content/doi/10.1108/FS-06-2019-0053/full/html"
  },
  {
    id: "j-75",
    type: "Journal Paper",
    year: "2020",
    title: "Modeling of strategic thinking enablers: a modified total interpretive structural modeling (TISM) and MICMAC approach",
    authors: "Dhir, S., & Dhir, S.",
    source: "International Journal of System Assurance Engineering and Management, 11(1), 175-188",
    link: "https://link.springer.com/article/10.1007/s13198-019-00937-z"
  },
  {
    id: "j-76",
    type: "Journal Paper",
    year: "2020",
    title: "A meta-analytical review of factors affecting the strategic thinking of an organization",
    authors: "Shaik, A. S., & Dhir, S.",
    source: "Foresight",
    link: "https://www.emerald.com/insight/content/doi/10.1108/FS-08-2019-0076/full/html"
  },
  {
    id: "j-77",
    type: "Journal Paper",
    year: "2020",
    title: "Mapping responsive retailing to identify future research trajectories",
    authors: "Sharma, D., Bindra, S., Taggar, R., Dhir, S., & Khoa, T. T.",
    source: "Journal for Global Business Advancement, 13(5), 584-604",
    link: "https://www.inderscienceonline.com/doi/abs/10.1504/JGBA.2020.112833"
  },
  {
    id: "j-78",
    type: "Journal Paper",
    year: "2020",
    title: "TISM modelling of social enterprise ecosystem: a study in Indian context",
    authors: "Jain, M., & Dhir, S.",
    source: "Journal for Global Business Advancement, 13(5), 665-681",
    link: "https://www.inderscienceonline.com/doi/abs/10.1504/JGBA.2020.112837"
  },
  {
    id: "j-79",
    type: "Journal Paper",
    year: "2020",
    title: "Retailer responsiveness: a total interpretive structural modelling approach",
    authors: "Sharma, D., Taggar, R., Bindra, S., & Dhir, S.",
    source: "Journal for Global Business Advancement, 13(3), 336-358",
    link: "https://www.inderscienceonline.com/doi/abs/10.1504/JGBA.2020.111014"
  },
  {
    id: "j-80",
    type: "Journal Paper",
    year: "2020",
    title: "Delivering high‐tech, AI‐based health care at Apollo Hospitals",
    authors: "Agarwal, Y., Jain, M., Sinha, S., & Dhir, S.",
    source: "Global Business and Organizational Excellence, 39(2), 20-30",
    link: "https://onlinelibrary.wiley.com/doi/full/10.1002/joe.21981"
  },
  {
    id: "j-81",
    type: "Journal Paper",
    year: "2019",
    title: "Structured review using TCCM and bibliometric analysis of international cause-related marketing, social marketing, and innovation of the firm",
    authors: "Singh, S., & Dhir, S.",
    source: "International Review on Public and Nonprofit Marketing, 16(2), 335-347",
    link: "https://link.springer.com/article/10.1007/s12208-019-00233-3"
  },
  {
    id: "j-82",
    type: "Journal Paper",
    year: "2019",
    title: "Analyzing the startup ecosystem of India: a Twitter analytics perspective",
    authors: "Singh, S., Chauhan, A., & Dhir, S.",
    source: "Journal of Advances in Management Research, 17(2), 262-281",
    link: "https://www.emerald.com/insight/content/doi/10.1108/JAMR-08-2019-0164/full/html"
  },
  {
    id: "j-83",
    type: "Journal Paper",
    year: "2019",
    title: "Strategic management: The evolution of the field",
    authors: "Bindra, S., Parameswar, N., & Dhir, S.",
    source: "Strategic Change, 28(6), 469-478",
    link: "https://onlinelibrary.wiley.com/doi/full/10.1002/jsc.2299"
  },
  {
    id: "j-84",
    type: "Journal Paper",
    year: "2019",
    title: "Factors affecting the choice of interaction after the international joint venture termination in Africa: Total interpretive structural modeling",
    authors: "Parameswar, N., & Dhir, S.",
    source: "Strategic Change, 28(6), 507-515",
    link: "https://onlinelibrary.wiley.com/doi/abs/10.1002/jsc.2302"
  },
  {
    id: "j-85",
    type: "Journal Paper",
    year: "2019",
    title: "Non-conformance in apparels: exploring online fashion retail in India",
    authors: "Kaushik, V., & Dhir, S.",
    source: "Journal of Fashion Marketing and Management, 23(2), 1361-2026",
    link: "https://www.emerald.com/insight/content/doi/10.1108/JFMM-05-2018-0067/full/html"
  },
  {
    id: "j-86",
    type: "Journal Paper",
    year: "2019",
    title: "Sustainable development in practice: Case study of L’Oréal",
    authors: "Withisuphakorn, P., Batra, I., Parameswar, N., & Dhir, S.",
    source: "Journal of Business and Retail Management Research, 13(Special)",
    link: ""
  },
  {
    id: "j-87",
    type: "Journal Paper",
    year: "2019",
    title: "Factors affecting the nature of alliance governance and competitiveness",
    authors: "Ongsakul, V., Parameswar, N., & Dhir, S.",
    source: "Journal of Business and Retail Management Research, 13(Special Issue), 9-23",
    link: ""
  },
  {
    id: "j-88",
    type: "Journal Paper",
    year: "2019",
    title: "Inter-partner dynamics and joint venture competitiveness: a fuzzy TISM approach",
    authors: "Bamel, N., Dhir, S., & Sushil, S.",
    source: "Benchmarking: An International Journal, 26(1), 97-116",
    link: "https://www.emerald.com/insight/content/doi/10.1108/BIJ-02-2018-0041/full/html"
  },
  {
    id: "j-89",
    type: "Journal Paper",
    year: "2019",
    title: "The Effects of Psychic Distance and Inter-Partner Fit on The Performance of International Joint Ventures",
    authors: "Batra, I., & Dhir, S.",
    source: "Asian Academy of Management Journal, 24(1), 151–173",
    link: "http://web.usm.my/aamj/24012019/aamj24012019_7.pdf"
  },
  {
    id: "j-90",
    type: "Journal Paper",
    year: "2019",
    title: "Modified total interpretive structural modelling (TISM) of asymmetric motives and its drivers in Indian bilateral CBJV",
    authors: "Hasan, Z., Dhir, S., & Dhir, S.",
    source: "Benchmarking: An International Journal, 26(2), 614-637",
    link: "https://www.emerald.com/insight/content/doi/10.1108/BIJ-01-2018-0020/full/html"
  },
  {
    id: "j-91",
    type: "Journal Paper",
    year: "2019",
    title: "Global marketplace strategy and choice of interaction after termination of international joint venture",
    authors: "Parameswar, N., & Dhir, S.",
    source: "Strategic Change, 28(3), 177-184",
    link: "https://onlinelibrary.wiley.com/doi/abs/10.1002/jsc.2260"
  },
  {
    id: "j-92",
    type: "Journal Paper",
    year: "2019",
    title: "Post termination interaction in international joint ventures (IJV)",
    authors: "Parameswar, N., & Dhir, S.",
    source: "Foresight, 21(2), 200-215",
    link: "https://www.emerald.com/insight/content/doi/10.1108/FS-03-2018-0022/full/html"
  },
  {
    id: "j-93",
    type: "Journal Paper",
    year: "2019",
    title: "Factors that drive development of technological entrepreneurship in South Asia",
    authors: "Parameswar, N., Hasan, Z., Dhir, S., & Ongsakul, V.",
    source: "Journal for Global Business Advancement, 12(3), 429-448",
    link: ""
  },
  {
    id: "j-94",
    type: "Journal Paper",
    year: "2019",
    title: "Ivey Publishing Case Study – Duckduckgo: Reinventing the Internet Search",
    authors: "Parameswar, N., Maddipatla, J., & Dhir, S.",
    source: "Ivey Publishing / Harvard Business Publishing (Product: W19276-PDF-ENG)",
    link: "https://store.hbr.org/product/duckduckgo-reinventing-the-internet-search/w19276"
  },
  {
    id: "j-95",
    type: "Journal Paper",
    year: "2019",
    title: "Twitter analysis of founders of top 25 Indian startups",
    authors: "Sindhani, M., Parameswar, N., Dhir, S., & Ongsakul, V.",
    source: "Journal for Global Business Advancement, 12(1), 117-144",
    link: "https://www.inderscienceonline.com/doi/abs/10.1504/JGBA.2019.099918"
  },
  {
    id: "j-96",
    type: "Journal Paper",
    year: "2018",
    title: "efin Recruiters: at the crossroads of the Indian RPO Industry",
    authors: "Parameswar, N., Singh, A., Malik, R., & Dhir, S.",
    source: "Emerald Emerging Markets Case Studies, 8(1), 1-23",
    link: "https://www.emerald.com/insight/content/doi/10.1108/EEMCS-03-2017-0031/full/html"
  },
  {
    id: "j-97",
    type: "Journal Paper",
    year: "2018",
    title: "Purpose of international joint venture and interaction post termination",
    authors: "Parameswar, N., Dhir, S., & Ongsakul, V.",
    source: "Journal for Global Business Advancement, 11(6), 687-705",
    link: "https://www.inderscienceonline.com/doi/abs/10.1504/JGBA.2018.097775"
  },
  {
    id: "j-98",
    type: "Journal Paper",
    year: "2018",
    title: "Organizational Capability and Performance Improvement: A Study of e-Commerce Firms in Indian Context",
    authors: "Dhir, S., & Dhir, S.",
    source: "International Journal of Global Business and Competitiveness, 13(1), 35-51",
    link: ""
  },
  {
    id: "j-99",
    type: "Journal Paper",
    year: "2018",
    title: "Role of Ambidexterity and Learning Capability in Firm Performance: A study of E-commerce industry in India",
    authors: "Dhir, S., & Dhir, S.",
    source: "VINE Journal of Information and Knowledge Management Systems, 48(4), 517-536",
    link: "https://www.emerald.com/insight/content/doi/10.1108/VJIKMS-10-2017-0073/full/html"
  },
  {
    id: "j-100",
    type: "Journal Paper",
    year: "2018",
    title: "An explorative study of trends, distribution and pattern of bilateral cross-border joint ventures (CBJVs)",
    authors: "Dhir, S., & Mital, A.",
    source: "Journal of Indian Business Research, 11(4), 323-347",
    link: "https://www.emerald.com/insight/content/doi/10.1108/JIBR-10-2017-0205/full/html"
  },
  {
    id: "j-101",
    type: "Journal Paper",
    year: "2018",
    title: "Comprehending ambidexterity in the emerging-market context: the moderating role of learning capability and environmental dynamism on e-commerce firms’ performance",
    authors: "Dhir, S., Ongsakul, V., & Batra, I.",
    source: "Journal for Global Business Advancement, 11(4), 395-417",
    link: "https://www.inderscience.com/info/inarticle.php?artid=97197"
  },
  {
    id: "j-102",
    type: "Journal Paper",
    year: "2018",
    title: "Defining and developing a scale to measure strategic thinking",
    authors: "Dhir, S., Dhir, S., & Samanta, P.",
    source: "Foresight, 20(3), 271-288",
    link: "https://www.emerald.com/insight/content/doi/10.1108/FS-10-2017-0059/full/html"
  },
  {
    id: "j-103",
    type: "Journal Paper",
    year: "2018",
    title: "Innovation driven ecosystem for quality skill development in India",
    authors: "Shrotriya, S., & Dhir, S.",
    source: "Benchmarking: An International Journal, 25(8), 2997-3020",
    link: "https://www.emerald.com/insight/content/doi/10.1108/BIJ-11-2017-0320/full/html"
  },
  {
    id: "j-104",
    type: "Journal Paper",
    year: "2017",
    title: "Flexibility in modification and termination of cross-border joint ventures",
    authors: "Dhir, S., & Sushil",
    source: "Global Journal of Flexible Systems Management, 18(2), 139-151",
    link: "https://link.springer.com/article/10.1007/s40171-017-0153-9"
  },
  {
    id: "j-105",
    type: "Journal Paper",
    year: "2017",
    title: "Banking on innovation, innovation in banking at ICICI bank",
    authors: "Parameswar, N., Dhir, S., & Dhir, S.",
    source: "Global Business and Organizational Excellence, 36(2), 6-16",
    link: "https://onlinelibrary.wiley.com/doi/abs/10.1002/joe.21765"
  },
  {
    id: "j-106",
    type: "Journal Paper",
    year: "2017",
    title: "Creating Value in Small-cap Firms by Mitigating Risks of Market Volatility",
    authors: "Khanra, S., & Dhir, S.",
    source: "Vision, 21(4), 350-355",
    link: "https://journals.sagepub.com/doi/abs/10.1177/0972262917733166"
  },
  {
    id: "j-107",
    type: "Journal Paper",
    year: "2017",
    title: "Adoption of open‐source software versus proprietary software: An exploratory study",
    authors: "Dhir, S., & Dhir, S.",
    source: "Strategic Change, 26(4), 363-371",
    link: "https://onlinelibrary.wiley.com/doi/abs/10.1002/jsc.2137"
  },
  {
    id: "j-108",
    type: "Journal Paper",
    year: "2017",
    title: "COMFED: The new challenges of diversification",
    authors: "Dhir, S., & Dhir, S.",
    source: "Emerald Emerging Markets Case Studies, 7(2), 1-26",
    link: "https://www.emerald.com/insight/content/doi/10.1108/EEMCS-09-2016-0188/full/html"
  },
  {
    id: "j-109",
    type: "Journal Paper",
    year: "2017",
    title: "Corporate risk scorecard: a comparative study of US and German firms risk score",
    authors: "Dhir, S., & Dhir, S.",
    source: "International Journal of Business Continuity and Risk Management, 7(4), 277-291",
    link: ""
  },

  // --- BOOK CHAPTERS (b-1 to b-6) ---
  {
    id: "b-1",
    type: "Book Chapter",
    year: "2024",
    title: "The Influence of Sustainable Technology Transfer and Sustainable Innovation on Green Growth",
    authors: "Pooja, Chikhale, M.M., & Dhir, S.",
    source: "In: Mohapatra, S., Padhi, P., Singh, V. (eds) Financial Markets, Climate Risk and Renewables. SEBF 2023. Springer Proceedings in Business and Economics. Springer, Singapore",
    link: "https://doi.org/10.1007/978-981-97-6687-1_9"
  },
  {
    id: "b-2",
    type: "Book Chapter",
    year: "2018",
    title: "MSME Competitiveness for the Global Value Chain-A TRIZ-Based Approach",
    authors: "Shrotriya, S., & Dhir, S.",
    source: "In Global Value Chains, Flexibility and Sustainability (pp. 33-46). Springer, Singapore",
    link: "https://link.springer.com/chapter/10.1007/978-981-10-8929-9_3"
  },
  {
    id: "b-3",
    type: "Book Chapter",
    year: "2018",
    title: "Technology Transfer and Innovation in Global International Joint Ventures-Emerging Markets’ Perspective",
    authors: "Parameswar, N., & Dhir, S.",
    source: "In Global Value Chains, Flexibility and Sustainability (pp. 77-87). Springer, Singapore",
    link: "https://link.springer.com/chapter/10.1007/978-981-10-8929-9_6"
  },
  {
    id: "b-4",
    type: "Book Chapter",
    year: "2017",
    title: "Lakshya Food (India) Limited: Growth and Expansion Strategy",
    authors: "Bamel, N., & Dhir, S.",
    source: "03/2017: pages 16; The Case Centre, ISBN: 317-0066-1",
    link: ""
  },
  {
    id: "b-5",
    type: "Book Chapter",
    year: "2016",
    title: "Global Competitiveness of Informal Economy Organizations",
    authors: "Dhir, S.",
    source: "Flexible Capacity Building in Asia and the Pacific, Edited by Sushil, 12/2016; Springer, DOI:10.1007/978-81-322-2834-9_14",
    link: "https://link.springer.com/chapter/10.1007/978-81-322-2834-9_14"
  },
  {
    id: "b-6",
    type: "Book Chapter",
    year: "2015",
    title: "The Walt Disney: Strategic acquisition for Achieving Creativity",
    authors: "Bamel, N., Sushil, & Dhir, S.",
    source: "Cases in Management – Economic Times, 12/2015: chapter 10: pages 74-78",
    link: ""
  }
];

export default function JournalPublications() {
  const [activeTab, setActiveTab] = useState('All'); // 'All' | 'Journal Paper' | 'Book Chapter'
  const [searchTerm, setSearchTerm] = useState('');
  const [copiedId, setCopiedId] = useState(null);

  const filteredItems = useMemo(() => {
    return publicationsData.filter((item) => {
      const matchesTab = activeTab === 'All' || item.type === activeTab;
      const q = searchTerm.toLowerCase();
      const matchesSearch =
        item.title.toLowerCase().includes(q) ||
        item.authors.toLowerCase().includes(q) ||
        item.source.toLowerCase().includes(q) ||
        item.year.includes(q);

      return matchesTab && matchesSearch;
    });
  }, [activeTab, searchTerm]);

  const handleCopyCitation = (item) => {
    const citation = `${item.authors} (${item.year}). ${item.title}. ${item.source}.`;
    navigator.clipboard.writeText(citation);
    setCopiedId(item.id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div className="container py-5 min-vh-100 position-relative text-light" style={{ zIndex: 1 }}>
      
      {/* 1. Header Banner */}
      <div className="row align-items-center g-4 mb-5">
        <div className="col-12 col-lg-8" data-aos="fade-right">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3 sub-badge">
            <BookOpen size={16} className="text-cyan" />
            <span className="small text-light fw-medium">Scholarly Output & Research Dissemination</span>
          </div>

          <h1 className="display-5 fw-bold text-white mb-3">
            Journal Publications & <br className="d-none d-md-block" />
            <span className="text-gradient">Book Chapters</span>
          </h1>

          <p className="lead text-secondary fs-6 mb-4 pe-lg-3">
            Over 110 peer-reviewed research papers and scholarly book chapters published across premier 
            international journals including <strong>IEEE Transactions</strong>, <strong>IJPE</strong>, 
            <strong> Technological Forecasting & Social Change</strong>, and <strong>Springer Nature</strong>.
          </p>

          {/* Quick Metrics Bar */}
          <div className="d-flex flex-wrap gap-3">
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-cyan">100+</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Journal Articles</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-warning">Springer</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Book Chapters</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-info">2012 – 2024</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Published Record</span>
            </div>
          </div>
        </div>

        {/* Global Citations Info Box */}
        <div className="col-12 col-lg-4" data-aos="fade-left">
          <div className="p-4 rounded-4 glass-panel border-glow text-center d-flex flex-column align-items-center justify-content-center h-100">
            <Layers size={40} className="text-cyan mb-3" />
            <h5 className="text-white fw-bold mb-2">High Citation Impact</h5>
            <p className="text-secondary small mb-0 lh-base">
              Focusing on empirical investigations in strategic flexibility, coopetition dynamics, TISM frameworks, and digital health operations.
            </p>
          </div>
        </div>
      </div>

      {/* 2. Search & Category Filter Section */}
      <div className="p-4 rounded-4 glass-panel mb-5" data-aos="fade-up">
        <div className="row g-3 align-items-center justify-content-between">
          
          {/* Search Box */}
          <div className="col-12 col-md-5">
            <div className="position-relative">
              <Search size={18} className="text-secondary position-absolute top-50 start-0 translate-middle-y ms-3" />
              <input
                type="text"
                placeholder="Search by title, author, journal, or year..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control rounded-pill ps-5 bg-dark text-light border border-secondary border-opacity-50 py-2 small"
              />
            </div>
          </div>

          {/* Result Count Indicator */}
          <div className="col-12 col-md-auto text-md-end text-secondary small">
            Showing <strong className="text-white">{filteredItems.length}</strong> of {publicationsData.length} records
          </div>
        </div>

        {/* Filter Navigation Tabs */}
        <div className="d-flex flex-wrap gap-2 mt-3 pt-3 border-top border-secondary border-opacity-25 align-items-center">
          <div className="d-flex align-items-center gap-1 text-secondary small me-2">
            <Filter size={14} /> Publication Type:
          </div>
          {['All', 'Journal Paper', 'Book Chapter'].map((tab, idx) => {
            const isSelected = activeTab === tab;
            return (
              <button
                key={idx}
                type="button"
                onClick={() => setActiveTab(tab)}
                className="btn btn-sm rounded-pill px-3 py-1 transition-all"
                style={{
                  fontSize: '0.8rem',
                  fontWeight: isSelected ? '700' : '500',
                  color: isSelected ? '#0a0f1d' : '#94a3b8',
                  background: isSelected ? 'linear-gradient(135deg, #00f2fe, #4facfe)' : 'rgba(255, 255, 255, 0.05)',
                  border: isSelected ? '1px solid #00f2fe' : '1px solid rgba(255, 255, 255, 0.15)',
                  boxShadow: isSelected ? '0 0 14px rgba(0, 242, 254, 0.45)' : 'none'
                }}
              >
                {tab === 'All' ? 'All Publications' : tab === 'Journal Paper' ? 'Journal Papers (100+)' : 'Book Chapters (6)'}
              </button>
            );
          })}
        </div>
      </div>

      {/* 3. Publications Grid */}
      <div className="row g-4">
        <AnimatePresence>
          {filteredItems.map((item, index) => {
            const isJournal = item.type === "Journal Paper";

            return (
              <motion.div
                layout
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.25 }}
                key={item.id}
                className="col-12 col-lg-6"
              >
                <div 
                  className="p-4 rounded-4 glass-panel h-100 d-flex flex-column justify-content-between position-relative overflow-hidden"
                  style={{
                    borderLeft: isJournal
                      ? '4px solid #00f2fe' 
                      : '4px solid #f59e0b'
                  }}
                >
                  <div>
                    {/* Badge Row */}
                    <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                      <span 
                        className="badge px-3 py-1 rounded-pill small"
                        style={{
                          background: isJournal ? 'rgba(0, 242, 254, 0.1)' : 'rgba(245, 158, 11, 0.1)',
                          color: isJournal ? '#00f2fe' : '#f59e0b',
                          border: isJournal ? '1px solid rgba(0, 242, 254, 0.25)' : '1px solid rgba(245, 158, 11, 0.25)',
                          fontSize: '0.72rem'
                        }}
                      >
                        {item.type}
                      </span>

                      <span className="small text-warning fw-semibold d-inline-flex align-items-center gap-1">
                        <Calendar size={13} /> {item.year}
                      </span>
                    </div>

                    {/* Paper Title */}
                    <h5 className="text-white fw-bold fs-6 mb-2 lh-base">
                      {item.title}
                    </h5>

                    {/* Authors List */}
                    <p className="text-light opacity-90 small mb-2">
                      {item.authors}
                    </p>

                    {/* Source / Journal */}
                    <p className="text-info small mb-3">
                      <em>{item.source}</em>
                    </p>
                  </div>

                  {/* Footer Citation & Direct Links */}
                  <div className="pt-3 border-top border-secondary border-opacity-15 d-flex align-items-center justify-content-between gap-2 text-secondary small">
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        onClick={() => handleCopyCitation(item)}
                        className="btn btn-sm btn-outline-glass text-secondary d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill"
                        style={{ fontSize: '0.72rem' }}
                        title="Copy APA Citation"
                      >
                        {copiedId === item.id ? (
                          <>
                            <Check size={12} className="text-success" />
                            <span className="text-success fw-bold">Copied</span>
                          </>
                        ) : (
                          <>
                            <Copy size={12} />
                            <span>Cite</span>
                          </>
                        )}
                      </button>
                    </div>

                    {item.link ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-info text-info rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"
                        style={{ fontSize: '0.75rem' }}
                      >
                        <span>Read Paper</span>
                        <ExternalLink size={12} />
                      </a>
                    ) : (
                      <span className="badge bg-dark border border-secondary border-opacity-50 text-secondary" style={{ fontSize: '0.7rem' }}>
                        Indexed Publication
                      </span>
                    )}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>

        {filteredItems.length === 0 && (
          <div className="col-12 text-center py-5">
            <p className="text-secondary fs-5 mb-0">No research publications found matching your search.</p>
          </div>
        )}
      </div>

    </div>
  );
}